import { CSSProperties } from 'react';

const dotStyles: CSSProperties = {
  position: 'absolute',
  bottom: 0,
  left: '50%',
  transform: 'translateX(-50%)',
  fontSize: '20px',
  color: 'red',
};

export const Dot = () => {
  return <span style={dotStyles}>•</span>;
};
